import { render, staticRenderFns } from "./auction-automation.vue?vue&type=template&id=71a2c21a&scoped=true"
import script from "./auction-automation.vue?vue&type=script&lang=js"
export * from "./auction-automation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2c21a",
  null
  
)

export default component.exports